// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3PabC","name":"Footer_name__234fH"};